import { z } from 'zod';
import { objectIdSchema } from '../../validation';

/**
 * Communication surface a `ChannelAccount` row represents.
 *
 * Generic across channels on purpose — the same collection later holds
 * per-org email inboxes and voice numbers, so "connect your WhatsApp /
 * email / phone to Hero" is one provisioning flow, not three
 * collections. See `docs/ai/whatsapp-agent.md` and
 * `docs/ai/decisions/014-generic-channel-account.md`.
 *
 * Lives in its own file (no model imports) so both
 * `channel-account.model.ts` and `conversation.model.ts` can import it
 * without a circular dependency.
 */
export const channelAccountTypeSchema = z.enum(['whatsapp', 'email', 'voice']);
export type ChannelAccountType = z.infer<typeof channelAccountTypeSchema>;

/**
 * Lightweight account handle passed through webhook / task flows before
 * stamping `Conversation.channel.channelAccountId`.
 */
export const channelAccountRefSchema = z.object({
  _id: objectIdSchema,
  type: channelAccountTypeSchema,
});
export type ChannelAccountRef = z.infer<typeof channelAccountRefSchema>;
